import { IconInfoCircleOutline } from '@iwoca/icons';
import { Table } from '@iwoca/orion';

export const HeaderInfoCell = ({
  header,
  className,
  onInfoClick,
}: {
  header: string;
  className?: string;
  onInfoClick: () => void;
}) => (
  <Table.HeaderCell className={className}>
    <button
      type="button"
      aria-label={`About ${header}`}
      onClick={onInfoClick}
      className="flex cursor-pointer items-center gap-s border-none bg-transparent p-0 uppercase [color:inherit] [font:inherit]"
    >
      {header}
      <IconInfoCircleOutline height={14} width={14} aria-hidden />
    </button>
  </Table.HeaderCell>
);
